import { USERNAME_MAX_LENGTH, USERNAME_MIN_LENGTH, USERNAME_REGEX } from './rules';

export function getIsUsernameValid(username = '') {
	return (
		username.length >= USERNAME_MIN_LENGTH &&
		username.length <= USERNAME_MAX_LENGTH &&
		username.match(USERNAME_REGEX)
	);
}

export function formatUsername(value = '') {
	return value && typeof value === 'string'
		? value
				?.trimStart()
				.replaceAll(' ', '_')
				.replaceAll(/[^a-zA-Z0-9_]/g, '')
		: value;
}
